import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UserImpersonationList from "../UserImpersonationList";

interface ImpersonationDialogProps {
  open: boolean;
  onClose: () => void;
}

const ImpersonationDialog: React.FC<ImpersonationDialogProps> = ({
  open,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Select a User to Impersonate
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <UserImpersonationList onComplete={onClose} />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ImpersonationDialog;
